/* Maison Bouali - capsule header : tiroir mobile. Header reste toujours visible en sticky (pas de masquage au scroll). Sans dependance. */
(function () {
  'use strict';

  function initDrawer() {
    var lastFocus = null;
    function close(drawer) {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    function open(drawer, trigger) {
      if (!drawer) return;
      lastFocus = trigger || null;
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    document.querySelectorAll('[data-mbn-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = document.getElementById(btn.getAttribute('data-mbn-drawer-open'));
        if (!drawer) return;
        if (drawer.getAttribute('data-open') === 'true') close(drawer);
        else open(drawer, btn);
      });
    });
    document.querySelectorAll('[data-mbn-drawer-close], .mbn-drawer__veil').forEach(function (el) {
      el.addEventListener('click', function () { close(el.closest('.mbn-drawer')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = document.querySelector('.mbn-drawer[data-open="true"]');
      if (d) close(d);
    });
  }

  function boot() { initDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
